module.exports = __webpack_public_path__ + "img/9788990769404.d29904cf.jpg";